import React from "react";
import { DetailAndAllowcateForEstimateContainer } from "../../../containers/SupportSystem/SupportForm/DetailAndAllowcateForEstimateContainer";

export function DetailAndAllocateForEstimatePage () {
    return(
        <DetailAndAllowcateForEstimateContainer/>
    )
}